<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import { useTheme } from '@/composables/useTheme'
import CookieBanner from '@/components/CookieBanner.vue'

const { isLoading } = useAuth()
useTheme()
</script>

<template>
  <div v-if="isLoading" class="loading-screen">
    <div class="spinner"></div>
  </div>
  <template v-else>
    <RouterView />
    <CookieBanner />
  </template>
</template>

<style>
.loading-screen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg);
}

.spinner {
  width: 36px;
  height: 36px;
  border: 2px solid var(--border-strong);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
